import React from 'react';
import { useField } from 'formik';
import Form from 'react-bootstrap/Form';
import styles from './lifestage.module.scss';
import medium from '../../../../assets/getstartedflow/weightChart/medium.png';
import large from '../../../../assets/getstartedflow/weightChart/large.png';
import vlarge from '../../../../assets/getstartedflow/weightChart/vlarge.png';

export enum InputAlign {
  LEFT = 'left',
  CENTER = 'center',
}

interface BreedProps {
  // name: string;
  inputAlign?: InputAlign;
  // nextStep: any
}
const lifestages = [
  {
    image: medium,
    label1: 'Under weight',
    label2:
      'Lean. Ribs are visible (or easily felt in long haired dogs). Obvious waist. Spine may be visible.',
    value: 'medium',
  },
  {
    image: large,

    label1: 'About right ',
    label2:
      'Ribs not visible but easily felt. A slight waist behind ribs. No excess fat.',
    value: 'large',
  },
  {
    image: vlarge,
    label1: 'Over Weight',
    label2:
      "Ribs and waistline nowhere to be found! Noticable fat across back and base of tail - 'a flat back'. Time for a diet!",
    value: 'very_large',
  },
];
const BodyType: React.FC<BreedProps> = props => {
  const [field, meta, helpers] = useField('bodyType');
  const { setValue, setTouched } = helpers;
  // const breedParentClasses = [styles.breedParent];

  // if (props.inputAlign === InputAlign.CENTER) {
  //   breedParentClasses.push(styles.breedParentCenter);
  // }

  // const setBreed = (breed: string) => {
  //   setValue(breed);
  //   setTouched(true);
  const setLifestage = (value: string) => {
    setValue(value);
    setTouched(true);
  };
  // };
  const value = meta?.value || '';
  return (
    <Form.Group controlId="formBreed" className={'align-col-cen'}>
      <Form.Label className='form-label'>Body condition... be honest !</Form.Label>
      <div className={styles.lifestageContainer}>
        {lifestages.map((it, index) => (
          <label className={styles.stageItem} key={'bodyType' + index}>
            <input
              type="radio"
              value={it.value}
              name="bodyType"
              checked={value == it.value}
              onClick={e => setLifestage(e.target.value)}
            />
            <div className="box">
              <div className="image-container">
                <img className="type-image" src={it.image} />
              </div>
              <div className="text-container">
                <div className="primary-text">{it.label1}</div>
                <div className="secondary-text">{it.label2}</div>
              </div>
            </div>
          </label>
        ))}
      </div>
    </Form.Group>

  );
};

export default BodyType;
